<template>
  <div id="demo-basic-card">
    <div class="vx-row flex justify-between flex-wrap">
      <div class="vx-col w-full mb-base">
        <vx-card no-shadow>
          <div class="mb-base">
            <h3 class="mb-4">Woocommerce to Hubspot Connection</h3>
            <div class="flex items-center mb-4">
              <vs-switch
                v-model="integration"
                v-on:click="updatecards()"
                v-if="
                  AppActiveUser.cards.active && AppActiveUser.cards.wooActive
                "
              />
              <vx-tooltip
                color="danger"
                text="Error in Hubspot and/or Woocommerce Connection"
                v-if="
                  !AppActiveUser.cards.active ||
                    !AppActiveUser.cards.wooActive
                "
              >
                <vs-switch
                  v-model="integration"
                  v-on:click="updatecards()"
                  disabled
                />
              </vx-tooltip>
              <span class="ml-4">Enable the integration</span>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row flex justify-between flex-wrap">
      <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
        <vx-card>
          <h2
            class="mb-2"
            v-if="AppActiveUser.cards.wooActive"
            style="text-decoration: underline;"
          >
            Source
          </h2>
          <div slot="no-body">
            <img
              :src="AppActiveUser.woocommerceImage"
              alt="content-img"
              class="responsive card-img-top"
            />
          </div>
          <h5 class="mb-2" v-if="AppActiveUser.cards.wooActive">
            {{ AppActiveUser.woocommerceTitle }}
          </h5>
          <p class="text-grey" v-if="AppActiveUser.cards.wooActive">
            Store URL: {{ AppActiveUser.cards.wooStoreUrl }}
          </p>
          <div class="flex justify-between flex-wrap">
            <vs-button
              class="mt-4 mr-2"
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-info"
              v-if="!AppActiveUser.cards.wooActive"
              @click="$router.push('/connections/woocommerce').catch(() => {})"
              >Connect Woocommerce</vs-button
            >
            <vs-button
              class="mt-4"
              color="success"
              type="filled"
              v-if="AppActiveUser.cards.wooActive"
              >Woocommerce Connected</vs-button
            >
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
        <vx-card
          class="vx-row flex justify-center items-center"
          style="height:100%;margin: 0 auto;"
        >
          <h4
            class="text-danger text-center"
            text-color="#E51A2F"
            v-if="
              !AppActiveUser.cards.active ||
                !AppActiveUser.cards.wooActive ||
                !AppActiveUser.cards.property_mappings.enabled
            "
          >
            Not Connected
          </h4>
          <h4
            class="text-success text-center"
            text-color="#169E78"
            v-if="
              AppActiveUser.cards.active &&
                AppActiveUser.cards.wooActive &&
                AppActiveUser.cards.property_mappings.enabled
            "
          >
            Connected
          </h4>
          <div class="flex justify-between flex-wrap">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Flat"
              height="150px"
              viewBox="0 0 512 512"
              width="150px"
              style="margin: 0 auto;"
              v-if="
                !AppActiveUser.cards.active ||
                  !AppActiveUser.cards.wooActive ||
                  !AppActiveUser.cards.property_mappings.enabled
              "
            >
              <g>
                <path
                  d="m56.013 224.006a24.019 24.019 0 0 1 -23.131-30.453 233.817 233.817 0 0 1 81.818-121.425 231.5 231.5 0 0 1 282.608 0 233.815 233.815 0 0 1 81.814 121.425 24 24 0 0 1 -46.236 12.894 185.51 185.51 0 0 0 -64.919-96.331 183.5 183.5 0 0 0 -223.925 0 185.505 185.505 0 0 0 -64.92 96.331 24.011 24.011 0 0 1 -23.109 17.559z"
                  fill="#8690fa"
                  data-original="#8690FA"
                  class=""
                  style="fill:#C12020"
                  data-old_color="#8690fa"
                />
                <path
                  d="m56 224a24 24 0 0 1 -23.964-22.669l-8-144a24 24 0 1 1 47.924-2.662l6.32 113.761 106.941-31.454a24 24 0 1 1 13.543 46.048l-135.995 40a23.947 23.947 0 0 1 -6.769.976z"
                  fill="#5153ff"
                  data-original="#5153FF"
                  class="active-path"
                  style="fill:#C12020"
                  data-old_color="#5153ff"
                />
                <path
                  d="m248 488a229.152 229.152 0 0 1 -141.3-48.128 233.817 233.817 0 0 1 -81.818-121.425 24 24 0 1 1 46.236-12.894 185.505 185.505 0 0 0 64.92 96.331 183.5 183.5 0 0 0 223.925 0 185.51 185.51 0 0 0 64.919-96.331 24 24 0 0 1 46.236 12.894 233.815 233.815 0 0 1 -81.818 121.425 229.152 229.152 0 0 1 -141.3 48.128z"
                  fill="#8690fa"
                  data-original="#8690FA"
                  class=""
                  style="fill:#C12020"
                  data-old_color="#8690fa"
                />
                <path
                  d="m455.979 480a24 24 0 0 1 -23.941-22.67l-6.32-113.76-106.941 31.454a24 24 0 0 1 -13.544-46.049l136-40a24 24 0 0 1 30.735 21.693l8 144a24 24 0 0 1 -22.631 25.294q-.686.038-1.358.038z"
                  fill="#5153ff"
                  data-original="#5153FF"
                  class="active-path"
                  style="fill:#C12020"
                  data-old_color="#5153ff"
                />
              </g>
            </svg>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Flat"
              height="150px"
              viewBox="0 0 512 512"
              width="150px"
              class="hovered-paths"
              style="margin: 0 auto;"
              v-if="
                AppActiveUser.cards.active &&
                  AppActiveUser.cards.wooActive &&
                  AppActiveUser.cards.property_mappings.enabled
              "
            >
              <g>
                <path
                  d="m56.013 224.006a24.019 24.019 0 0 1 -23.131-30.453 233.817 233.817 0 0 1 81.818-121.425 231.5 231.5 0 0 1 282.608 0 233.815 233.815 0 0 1 81.814 121.425 24 24 0 0 1 -46.236 12.894 185.51 185.51 0 0 0 -64.919-96.331 183.5 183.5 0 0 0 -223.925 0 185.505 185.505 0 0 0 -64.92 96.331 24.011 24.011 0 0 1 -23.109 17.559z"
                  fill="#8690fa"
                  data-original="#8690FA"
                  class="active-path"
                  style="fill:#69E781"
                  data-old_color="#8690fa"
                />
                <path
                  d="m56 224a24 24 0 0 1 -23.964-22.669l-8-144a24 24 0 1 1 47.924-2.662l6.32 113.761 106.941-31.454a24 24 0 1 1 13.543 46.048l-135.995 40a23.947 23.947 0 0 1 -6.769.976z"
                  fill="#5153ff"
                  data-original="#5153FF"
                  class="hovered-path"
                  style="fill:#69E781"
                  data-old_color="#5153ff"
                />
                <path
                  d="m248 488a229.152 229.152 0 0 1 -141.3-48.128 233.817 233.817 0 0 1 -81.818-121.425 24 24 0 1 1 46.236-12.894 185.505 185.505 0 0 0 64.92 96.331 183.5 183.5 0 0 0 223.925 0 185.51 185.51 0 0 0 64.919-96.331 24 24 0 0 1 46.236 12.894 233.815 233.815 0 0 1 -81.818 121.425 229.152 229.152 0 0 1 -141.3 48.128z"
                  fill="#8690fa"
                  data-original="#8690FA"
                  class="active-path"
                  style="fill:#69E781"
                  data-old_color="#8690fa"
                />
                <path
                  d="m455.979 480a24 24 0 0 1 -23.941-22.67l-6.32-113.76-106.941 31.454a24 24 0 0 1 -13.544-46.049l136-40a24 24 0 0 1 30.735 21.693l8 144a24 24 0 0 1 -22.631 25.294q-.686.038-1.358.038z"
                  fill="#5153ff"
                  data-original="#5153FF"
                  class="hovered-path"
                  style="fill:#69E781"
                  data-old_color="#5153ff"
                />
              </g>
            </svg>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
        <vx-card style="height:100%;">
          <h2
            class="mb-2"
            v-if="AppActiveUser.cards.active"
            style="text-decoration: underline;"
          >
            Destination
          </h2>

          <div slot="no-body">
            <img
              :src="AppActiveUser.hubspotImage"
              alt="content-img"
              class="responsive card-img-top"
            />
          </div>
          <h5 class="mb-2" v-if="AppActiveUser.cards.active">
            {{ AppActiveUser.hubspotTitle }}:
            {{ AppActiveUser.cards.portal_id }}
          </h5>
          <p class="text-grey" v-if="AppActiveUser.cards.active">
            Portal URL: {{ AppActiveUser.cards.url }}
          </p>
          <div class="flex justify-between flex-wrap">
            <vs-button
              class="mt-4 mr-2"
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-info"
              v-if="!AppActiveUser.cards.active"
              @click="$router.push('/connections/hubspot').catch(() => {})"
              >Connect Hubspot Portal</vs-button
            >
            <vs-button
              class="mt-4"
              color="success"
              type="filled"
              v-if="AppActiveUser.cards.active"
              >Hubspot Portal Connected</vs-button
            >
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
      integration: {
        get () {
          if('property_mappings' in this.$store.state.AppActiveUser.cards && this.$store.state.AppActiveUser.cards.property_mappings != "" ){
            return this.$store.state.AppActiveUser.cards.property_mappings.enabled
          } else {            
            this.$store.commit('UPDATE_PROPERTY_MAPPINGS', this.$store.state.AppActiveUser.defaultState.cards.property_mappings)
            return this.$store.state.AppActiveUser.defaultState.cards.property_mappings.enabled
          }
        },
        set (value) {
          this.$store.commit('UPDATE_ENABLED', value)
        }
      },
      ...mapState(['AppActiveUser'])
    },
    methods: {    
      updatecards: function() {
        if(this.AppActiveUser.cards.active || this.AppActiveUser.cards.wooActive){        
          let cThis = this;
          setTimeout(function() {
            cThis.$store.dispatch('updateMappingsData', cThis.AppActiveUser.cards);
          }, 200);
        }
      }
    }
  };
</script>